export default __webpack_public_path__ + "static/media/CourseThumbnail-UNP01.cf855c32.png";